import type { StripeError } from "@stripe/stripe-js";

/**
 * Wraps a Stripe.js client-side error - returned from elements.submit(),
 * confirmPayment(), confirmCardPayment(), or confirmSetup() - rather than an
 * error from our own API. Stripe explicitly documents these messages (card
 * declines, invalid zip/card details, etc.) as safe to show directly to
 * donors, unlike an arbitrary JS Error's message.
 */
export class StripeClientError extends Error {
  public type: StripeError["type"];
  public code?: string;

  public constructor(stripeError: StripeError, defaultMessage: string) {
    super(stripeError.message || defaultMessage);
    this.type = stripeError.type;
    this.code = stripeError.code;
  }
}
